<template>     
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>  
        <v-card>      
          <v-card-actions class="px-3">
            <span>Silahkan cetak kartu ujian anda.</span>
            <v-spacer></v-spacer>
            <v-btn class="blue-grey" @click="printerPlugin()" dark><v-icon> print</v-icon>Print</v-btn>
          </v-card-actions>
          <v-card-text class="printcontent" style="height: 700px; margin-top:30px">
            <v-layout text-xs-center align-center wrap>    
              <div style="border: 1px solid #aaa; border-radius:20px; min-width:350px; width:350px;" class="blue lighten-2 ml-3 white--text">
                <v-layout row wrap>
                  <v-flex xs12 >
                    <table style="width:100%">
                      <thead>
                        <tr>
                          <th style="width:80px">
                            <img
                              :src="require('@/assets/logo.png')"
                              class="my-3"
                              style="height:50px;"
                            ></img>
                          </th>
                          <th>
                            <h4 style="font-size:12px" class="indigo--text">PERGURUAN ISLAM <span class="green--text">AR RISALAH</span></h4>
                            <h2 style="font-size:14px">Kartu Peserta Ujian Online</h2>                      
                            <h4 style="font-size:12px">TAHUN AJARAN 2021/2022</h4>
                          </th>
                        </tr>
                      </thead>
                    </table>
                    <hr />
                  </v-flex>          
                  <v-flex xs12>  
                    <v-layout row wrap>
                      <v-flex xs3 class="text-xs-left">
                        <div style="width:70px; height:70px; border:1px solid #eee; position: relative" class="text-xs-center mx-3 mb-2">
                          <img v-if="imgUrl" :src="imgUrl ? imgUrl : require('@/assets/img/avatar.png')" style="max-width:100%; max-height:150px;" />
                          <span  @click="cropshow=true" v-else class="caption">Pas Foto</span>                               
                        </div>
                      </v-flex>
                      <v-flex xs9>
                        <table style="font-size:11px">
                          <tbody>
                            <tr>
                              <td class="text-xs-left" valign="top"><strong>Nama Peserta</strong></td><td>:</td><td class="text-xs-left pl-1"><strong>{{fm.nama}}</strong></td>
                            </tr>
                            <tr>
                              <td></td>
                            </tr>
                            <tr>
                              <td class="text-xs-left" valign="top">Nama Orang Tua</td><td>:</td><td class="text-xs-left pl-1">{{fm.ayah_nama}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left" valign="top">Nomor Ujian</td><td>:</td><td class="text-xs-left pl-1">{{fm.calonGedung.number}}</td>
                            </tr>                  
                          </tbody>
                        </table>                                    
                      </v-flex>   
                    </v-layout>     
                    <hr/>           
                  </v-flex>
                  <v-flex xs12 class="pa-3">              
                    <h3 class="caption">Padang, {{$moment().format('DD MMM YYYY')}}</h3>
                    <h3 class="caption">Ketua Panitia PPDB</h3>
                    <img src="@/assets/img/ttdsyatri.png" style="max-height:110px; margin-top:-30px; margin-bottom:-30px" />              
                    <h3 class="caption">SYATRI, S.E., M.Pd.</h3>
                    <h3 class="caption">NIKY. 2008.01.1984.11.21-007 </h3>
                  </v-flex>  
                </v-layout>        
              </div>              
            </v-layout>      
          </v-card-text>   
        </v-card>
      </v-container>
    </div>
  </v-slide-y-transition>  
</template>
<script>
import Model from '@/apps/admin/models/Calon';
const  model = new Model();

export default {  
  data:()=>({  
    stepkeLocal : null,
    conti : false,    
    imgLoading : false,
    imgUrl : null,
    fm : {
      user : {
          username : null,
          phone : null,
          password : null,
          status : 10,
      },
      user_id : null,
      tingkat_id : null,
      jurusan_id : null,
      nama : null,
      gender : null,
      lahir_tempat : null,
      lahir_tanggal : null,
      lahir_tanggalV : null,
      alamat : null,
      kelurahan_id : null,
      kecamatan_id : null,
      kota_id : null,
      provinsi_id : null,
      prestasi_osn : null,
      prestasi_mtq : null,
      prestasi_hafidz : null,
      prestasi_other : null,
      sekolah_nama : null,
      sekolah_provinsi_id : null,
      sekolah_kota_id : null,
      telepon : null,
      whatsapp : null,
      email : null,
      ayah_nama : null,
      ayah_pekerjaan : null, 
      ayah_jabatan : null,
      ayah_penghasilan : null,
      ibu_nama : null,
      ibu_pekerjaan : null, 
      ibu_jabatan : null,
      ibu_penghasilan : null,
      calonPrestasis : [],
      calonGedung : {
        gedung : {},
        ruang : {}
      }
    },
  }),
  mounted(){
    model.cekRuangan({id : this.$route.query.id }).then(data=>{
      this.init(); 
    })    
  },
  methods:{
    init(){
      if(this.$route.query.id){        
        model.one({id : this.$route.query.id }).then(data => {
          Object.assign(this.fm, data);             
          this.getavatar();
        });
      }  
    },
    
    getJadwalUjian(tingkat){
      switch(tingkat){case 2:return 'Sabtu, 4 Januari 2020, 07:00 WIB'; break; case 3:return 'Ahad, 23 Februari 2020, 07:00 WIB'; break; default:return 'none'; break;}
    },
    
    printerPlugin(){
      this.conti = true;      
      print();
    },        
    
    getavatar(){
      this.imgLoading  = true;
      model.getavatar({reff_id:this.fm.user_id}).then(res=>{
        if(res.data){
          this.imgUrl      = res.data;          
        }
        this.imgLoading  = false;
      });
    },
  }
};
</script>
<style>
.printcontent * {visibility: visible; color:#000;}  
.printcontent {position : relative; top:0px; left:0px; z-index: 0}  
@media print
{
    body * {visibility:hidden;}
    .printcontent * {visibility : visible;}
    .printcontent {position : fixed; top:0px; left:0px;}
}
</style> 

